import { memo, SVGProps } from 'react'

export const SettingsHeaderIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.359 52.637v-9.275l-5.5-5.836 11-19.052 7.804 1.845 8.032-4.638L37 8h22l2.304 7.681 8.032 4.638 7.805-1.845 11 19.052-5.5 5.836v9.275l5.5 5.837-11 19.052-7.804-1.845-8.033 4.638L59 88H37l-2.305-7.681-8.032-4.638-7.804 1.845-11-19.052 5.5-5.837zM31.999 48c0-8.837 7.164-16 16-16 8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.836 0-16-7.163-16-16z"
        fill="url(#settings-dark_svg__paint0_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48 76c-15.464 0-28-12.536-28-28s12.536-28 28-28 28 12.536 28 28-12.536 28-28 28zM32 48c0 8.837 7.163 16 16 16s16-7.163 16-16-7.163-16-16-16-16 7.163-16 16z"
        fill="url(#settings-dark_svg__paint1_linear)"
      />
      <path d="M85 12l4 4 4-4-4-4-4 4zM71 85l3 3 3-3-3-3-3 3zM2 46h3v-3H2v3z" fill="#474D57" />
      <circle cx="48" cy="48" r="5" fill="#474D57" />
      <defs>
        <linearGradient
          id="settings-dark_svg__paint0_linear"
          x1="48"
          y1="88"
          x2="48"
          y2="8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0B90B" />
          <stop offset="1" stopColor="#F8D33A" />
        </linearGradient>
        <linearGradient
          id="settings-dark_svg__paint1_linear"
          x1="48"
          y1="20"
          x2="48"
          y2="76"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#929AA5" />
          <stop offset="1" stopColor="#76808F" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const MyProfileIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 13a4 4 0 00-4 4v4h18v-4a4 4 0 00-4-4h-2l-3 3-3-3H7z"
        fill="#76808F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 6.5a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0z"
        fill="url(#user-g_svg__paint0_linear)"
      />
      <defs>
        <linearGradient id="user-g_svg__paint0_linear" x1="12" y1="11" x2="12" y2="2" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F0B90B" />
          <stop offset="1" stopColor="#F8D33A" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const CloseIcon = memo((props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M6.697 4.575L4.575 6.697 9.88 12l-5.304 5.303 2.122 2.122L12 14.12l5.303 5.304 2.122-2.122L14.12 12l5.304-5.303-2.122-2.122L12 9.88 6.697 4.575z"
        fill="currentColor"
      />
    </svg>
  )
})
